import React from 'react'
import Table3 from '../Table/table3'

const Dashboard = () => {
  return (
    <>

    <div style={{width:'20%',height:'100vh'}}>
    <Table3/>
    </div>
    
    </>
  )
}

export default Dashboard